var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Settings")]),_c('router-link',{attrs:{"to":"/settings/lookups"}},[_vm._v("Lookups")]),_c('video',{ref:"video",attrs:{"id":"video","width":"100%","height":"100%","autoplay":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }